import { useEffect, useMemo } from 'react';
import { RouteSuggestion } from '@lifeomic/phc-web-toolkit/src/components/Omnibar/types';
import { useIntl } from 'react-intl';
import { messages } from '@lifeomic/phc-web-toolkit/src/components/Omnibar/messages';

import pwtUrls from '@lifeomic/phc-web-toolkit/src/util/urls';
import urls from '../../../util/urls';
import { useOmnibarContext } from '@lifeomic/phc-web-toolkit/src/components/Omnibar/OmnibarProvider';

export const useRouteSuggestions = () => {
  const { formatMessage } = useIntl();
  const routes: RouteSuggestion[] = useMemo(
    () => [
      {
        value: formatMessage(messages.subjectsRoute),
        display: formatMessage(messages.subjectsRouteDisplay),
        path: urls.app.patients(),
        type: 'route',
      },
      {
        value: formatMessage(messages.surveysRoute),
        display: formatMessage(messages.surveysRouteDisplay),
        path: pwtUrls.app.manageSurveys(),
        type: 'route',
      },
      {
        value: formatMessage(messages.insightsRoute),
        display: formatMessage(messages.insightsRouteDisplay),
        path: urls.app.insights(),
        type: 'route',
      },
      {
        value: formatMessage(messages.cohortsRoute),
        display: formatMessage(messages.cohortsRouteDisplay),
        path: urls.app.cohorts(),
        type: 'route',
      },
      {
        value: formatMessage(messages.tasksRoute),
        display: formatMessage(messages.tasksRouteDisplay),
        path: urls.app.tasks(),
        type: 'route',
      },
      {
        value: formatMessage(messages.filesRoute),
        display: formatMessage(messages.filesRouteDisplay),
        path: urls.app.files(),
        type: 'route',
      },
      {
        value: formatMessage(messages.knowledgeRoute),
        display: formatMessage(messages.knowledgeRouteDisplay),
        path: urls.app.projectKnowledge(),
        type: 'route',
      },
      {
        value: formatMessage(messages.addDataRoute),
        display: formatMessage(messages.addDataRouteDisplay),
        path: urls.app.addData(),
        type: 'route',
      },
      {
        value: formatMessage(messages.genomicsRoute),
        display: formatMessage(messages.genomicsRouteDisplay),
        path: urls.app.omics.dashboard(),
        type: 'route',
      },
      {
        value: formatMessage(messages.consentRoute),
        display: formatMessage(messages.consentRouteDisplay),
        path: urls.app.consent(),
        type: 'route',
      },
    ],
    [formatMessage],
  );

  const { searchValue, registerSuggestions, unregisterSuggestions } =
    useOmnibarContext();

  useEffect(() => {
    const filteredRoutes = routes.filter(route =>
      route.value.toLowerCase().includes(searchValue.toLowerCase()),
    );
    registerSuggestions({
      id: 'routeSuggestions',
      loading: false,
      suggestions: filteredRoutes,
    });

    return () => {
      unregisterSuggestions('routeSuggestions');
    };
  }, [registerSuggestions, routes, searchValue, unregisterSuggestions]);
};
